import React from "react";
import { Link } from "react-router-dom";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import { Button } from "../components/ui/button";

const HomePage = () => {
  return (
    <div className="min-h-screen page-enter">
      {/* Main Content Area with Video Background */}
      <div className="relative">
        {/* Video Background - Only for main content */}
        <video
          className="absolute inset-0 w-full h-full object-cover"
          autoPlay
          loop
          muted
          playsInline
        >
          <source src="https://customer-assets.emergentagent.com/job_centered-nav/artifacts/nqh3uio8_Stationary%20of%20Skis.mp4" type="video/mp4" />
        </video>

        {/* Navigation */}
        <div className="absolute top-0 left-0 right-0 z-20 slide-in-top">
          <Navigation />
        </div>
        
        {/* Hero Content with Staggered Animation */}
        <div className="min-h-screen flex flex-col justify-center items-center text-center px-6 relative z-10 pointer-events-none">
            <div className="max-w-4xl">
              <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight drop-shadow-2xl slide-in-bottom">
                Take a trip that will build more than{" "}
                <span className="bg-gradient-to-r from-blue-300 to-white bg-clip-text text-transparent whitespace-nowrap" style={{backgroundImage: 'linear-gradient(to right, #93c5fd, white)'}}>memories</span>
              </h1>
              <p className="text-xl md:text-2xl text-white mb-8 max-w-3xl mx-auto leading-relaxed drop-shadow-xl stagger-1">
                Connect with like-minded and like-cultured professionals through adventure travel, leisure & lifestyle activities, and social events.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center stagger-2 pointer-events-auto">
                <Button 
                  size="lg" 
                  className="text-white px-8 py-4 text-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl backdrop-blur-sm hover-lift"
                  style={{
                    background: 'rgba(255, 255, 255, 0.2)',
                    border: '2px solid rgba(255, 255, 255, 0.3)',
                    backdropFilter: 'blur(10px)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = 'rgba(255, 255, 255, 0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                  }}
                  onClick={() => window.open('https://linktr.ee/takeatripnyc', '_blank')}
                >
                  Join Our Community
                </Button>
                <Link to="/about">
                  <Button 
                    size="lg" 
                    variant="outline"
                    className="px-8 py-4 text-lg transition-all duration-300 text-white backdrop-blur-sm hover-lift"
                    style={{
                      borderColor: 'rgba(255, 255, 255, 0.5)',
                      color: 'white',
                      background: 'rgba(255, 255, 255, 0.1)'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    }}
                  >
                    Learn More
                  </Button>
                </Link>
              </div>
            </div>

            {/* NYC Skyline Silhouette */}
            <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black/20 to-transparent z-0 fade-in">
              <div className="absolute bottom-0 left-0 right-0 h-24" style={{background: 'linear-gradient(to right, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.3))'}}>
                <div className="skyline-silhouette"></div>
              </div>
            </div>
          </div>
      </div>
      
      {/* Footer - Separate from video background */}
      <Footer />
    </div>
  );
};

export default HomePage;